import type { MappedSportWithNationality } from '../Components/NationalFlagIcon/types'

export function mapLeagueToSportWithNationalFlags({
  leagueId,
}: {
  leagueId: number
}): MappedSportWithNationality | null {
  switch (leagueId) {
    // cricket
    case LocalConstants.CricketOneDayMatch:
    case LocalConstants.CricketAsiaCup:
    case LocalConstants.CricketICCT20WorldCup:
    case LocalConstants.CricketICCChampionsTrophy:
    case LocalConstants.CricketOneDaySeries:
    case LocalConstants.CricketICCWC2027:
      return 'Cricket'

    // rugby league
    case LocalConstants.RugbyLeagueEuropeanChampionship:
    case LocalConstants.RugbyLeagueFourNations:
    case LocalConstants.RugbyLeagueInternational:
    case LocalConstants.RugbyLeagueInternationalW:
    case LocalConstants.RugbyLeagueOceaniaCup:
    case LocalConstants.RugbyLeaguePacificChampionships:
    case LocalConstants.RugbyLeaguePacificChampionshipsW:
    case LocalConstants.RugbyLeagueWorldClubChallenge:
    case LocalConstants.RugbyLeagueWorldCup:
    case LocalConstants.RugbyLeagueWorldCupW:
    case LocalConstants.RugbyLeagueWorldCup9s:
    case LocalConstants.RugbyLeagueWorldCup9sW:
      return 'RugbyLeague'

    // rugby union
    case LocalConstants.RugbyUnionMenWC2027:
      return 'RugbyUnion'

    // basketball
    case LocalConstants.BasketballAfrobasket:
    case LocalConstants.BasketballAfrobasketW:
    case LocalConstants.BasketballAfrobasketWQualifiers:
    case LocalConstants.BasketballAfrobasketQualifiers:
    case LocalConstants.BasketballAsianGames:
    case LocalConstants.BasketballAsianGamesMen:
    case LocalConstants.BasketballAsianGamesWomen:
    case LocalConstants.BasketballEuroBasket:
    case LocalConstants.BasketballEuroBasketW:
    case LocalConstants.BasketballEuroBasketQualification:
    case LocalConstants.BasketballEuroBasketQualificationW:
    case LocalConstants.BasketballEuroCup:
    case LocalConstants.BasketballEuroCupW:
    case LocalConstants.BasketballEuroCupQualificationW:
    case LocalConstants.BasketballFIBA3x3WorldCup:
    case LocalConstants.BasketballFIBA3x3WorldCupW:
    case LocalConstants.BasketballFIBAAmeriCup:
    case LocalConstants.BasketballFIBAAmeriCupW:
    case LocalConstants.BasketballFIBAAmeriCupQualification:
    case LocalConstants.BasketballFIBAAsiaChampionsCup:
    case LocalConstants.BasketballFIBAAsiaChampionsCupQual:
    case LocalConstants.BasketballFIBAAsiaChampionship:
    case LocalConstants.BasketballFIBAAsiaCup:
    case LocalConstants.BasketballFIBAAsiaCupW:
    case LocalConstants.BasketballFIBAAsiaCupQualification:
    case LocalConstants.BasketballFIBACaribbeanChampionshipW:
    case LocalConstants.BasketballFIBACentralAmericanChampionshipW:
    case LocalConstants.BasketballFIBACentralAmericanChampionshipU19W:
    case LocalConstants.BasketballFIBACentrobasketChampionship:
    case LocalConstants.BasketballFIBACentrobasketChampionshipW:
    case LocalConstants.BasketballFIBAOceaniaChampionships:
    case LocalConstants.BasketballFIBAOceaniaChampionshipsW:
    case LocalConstants.BasketballFIBASouthAmericanChampionship:
    case LocalConstants.BasketballFIBASouthAmericanChampionshipW:
    case LocalConstants.BasketballFIBAWorldCup:
    case LocalConstants.BasketballFIBAWorldCupW:
    case LocalConstants.BasketballFIBAWorldCupWQualification:
    case LocalConstants.BasketballFIBAWorldCupWQualificationAfrica:
    case LocalConstants.BasketballFIBAWorldCupWQualificationAmericas:
    case LocalConstants.BasketballFIBAWorldCupWQualificationAsia:
    case LocalConstants.BasketballFIBAWorldCupWQualificationEurope:
    case LocalConstants.BasketballFIBAWorldCupQualificationAfrica:
    case LocalConstants.BasketballFIBAWorldCupQualificationAmericas:
    case LocalConstants.BasketballFIBAWorldCupQualificationAsia:
    case LocalConstants.BasketballFIBAWorldCupQualificationEurope:
    case LocalConstants.BasketballInternationalFriendlyMatches:
    case LocalConstants.BasketballInternationalFriendlyMatchesW:
    case LocalConstants.BasketballInternationalTournaments:
    case LocalConstants.BasketballInternationalTournamentsAfroCan:
    case LocalConstants.BasketballInternationalTournamentsArabChampionship:
    case LocalConstants.BasketballInternationalTournamentsCentralAmericanAndCaribbeanGames:
    case LocalConstants.BasketballInternationalTournamentsEuropeanChampionshipForSmallCountries:
    case LocalConstants.BasketballInternationalTournamentsGamesOfTheSmallStatesOfEurope:
    case LocalConstants.BasketballInternationalTournamentsSouthAsianGames:
    case LocalConstants.BasketballInternationalTournamentsSouthEastAsianGames:
    case LocalConstants.BasketballInternationalTournamentsWilliamJonesCup:
    case LocalConstants.BasketballInternationalTournamentsW:
    case LocalConstants.BasketballInternationalTournamentsWCentralAmericanAndCaribbeanGames:
    case LocalConstants.BasketballInternationalTournamentsWEuropeanChampionshipForSmallCountries:
    case LocalConstants.BasketballInternationalTournamentsWGamesOfTheSmallStatesOfEurope:
    case LocalConstants.BasketballInternationalTournamentsWSouthAsianGames:
    case LocalConstants.BasketballInternationalTournamentsWSouthEastAsianGames:
    case LocalConstants.BasketballInternationalTournamentsWWilliamJonesCup:
    case LocalConstants.BasketballInternationalYouthFriendlies:
    case LocalConstants.BasketballInternationalYouthFriendliesUnder18:
    case LocalConstants.BasketballInternationalYouthFriendliesUnder19:
    case LocalConstants.BasketballInternationalYouthFriendliesUnder20:
    case LocalConstants.BasketballInternationalYouthFriendliesUnder21:
    case LocalConstants.BasketballInternationalYouthFriendliesUnder23:
    case LocalConstants.BasketballInternationalYouthFriendliesW:
    case LocalConstants.BasketballInternationalYouthFriendliesWUnder17:
    case LocalConstants.BasketballInternationalYouthFriendliesWUnder18:
    case LocalConstants.BasketballInternationalYouthFriendliesWUnder19:
    case LocalConstants.BasketballInternationalYouthFriendliesWUnder20:
    case LocalConstants.BasketballInternationalYouthFriendliesWUnder21:
    case LocalConstants.BasketballInternationalYouthFriendliesWUnder22:
    case LocalConstants.BasketballInternationalYouthFriendliesWUnder23:
    case LocalConstants.BasketballInternationalYouthTournaments:
    case LocalConstants.BasketballInternationalYouthTournamentsAmericasChampionshipU21:
    case LocalConstants.BasketballInternationalYouthTournamentsBalticSeaCupU18:
    case LocalConstants.BasketballInternationalYouthTournamentsEuropeanChampionshipU18:
    case LocalConstants.BasketballInternationalYouthTournamentsEuropeanChampionshipU19:
    case LocalConstants.BasketballInternationalYouthTournamentsEuropeanChampionshipU20DivA:
    case LocalConstants.BasketballInternationalYouthTournamentsEuropeanChampionshipU20DivB:
    case LocalConstants.BasketballInternationalYouthTournamentsFIBAEuropeanChallengersU20:
    case LocalConstants.BasketballInternationalYouthTournamentsFIBASouthAmericanChampionshipU18:
    case LocalConstants.BasketballInternationalYouthTournamentsOceaniaChampionshipsU19:
    case LocalConstants.BasketballInternationalYouthTournamentsWorldCupU17:
    case LocalConstants.BasketballInternationalYouthTournamentsWorldCupU19:
    case LocalConstants.BasketballInternationalYouthTournamentsW:
    case LocalConstants.BasketballInternationalYouthTournamentsWAmericasChampionshipU17:
    case LocalConstants.BasketballInternationalYouthTournamentsWBalticSeaCupU18:
    case LocalConstants.BasketballInternationalYouthTournamentsWEuropeanChampionshipU16:
    case LocalConstants.BasketballInternationalYouthTournamentsWEuropeanChampionshipU18:
    case LocalConstants.BasketballInternationalYouthTournamentsWEuropeanChampionshipU19:
    case LocalConstants.BasketballInternationalYouthTournamentsWEuropeanChampionshipU20DivA:
    case LocalConstants.BasketballInternationalYouthTournamentsWEuropeanChampionshipU20DivB:
    case LocalConstants.BasketballInternationalYouthTournamentsWFIBAEuropeanChallengersU20:
    case LocalConstants.BasketballInternationalYouthTournamentsWOceaniaChampionshipU19:
    case LocalConstants.BasketballInternationalYouthTournamentsWWorldCupU19:
    case LocalConstants.BasketballOlympicGames:
    case LocalConstants.BasketballOlympicGamesMen:
    case LocalConstants.BasketballOlympicGamesWomen:
    case LocalConstants.BasketballOlympicQualification:
    case LocalConstants.BasketballOlympicQualificationW:
      return 'Basketball'

    // football
    case LocalConstants.FootballWC2026:
    case LocalConstants.FootballWC2022:
    case LocalConstants.FootballWCQualifier2026:
    case LocalConstants.FootballWCMatches:
    case LocalConstants.FootballCopaAmerica:
    case LocalConstants.FootballFIFAClubWorldCup:
    case LocalConstants.FootballWorldCupQualifyingEurope:
    case LocalConstants.FootballWorldCupQualifyingAsia:
    case LocalConstants.FootballAfricaCupOfNations:
    case LocalConstants.FootballWorldCupQualifyingAfrica:
    case LocalConstants.FootballAsianGames:
      return 'Football'

    // f1
    case LocalConstants.F1:
    case LocalConstants.F1Race:
    case LocalConstants.F1SeasonBet:
      return 'F1'

    // ufc
    case LocalConstants.UFC:
      return 'UFC'

    default:
      return null
  }
}

// ======
// Locals
// ======

const enum LocalConstants {
  //cricket
  CricketOneDayMatch = 2000125174,
  CricketOneDaySeries = 2000125175,
  CricketICCWC2027 = 2010201746,
  CricketICCT20WorldCup = 2010203792,
  CricketICCChampionsTrophy = 2010202709,
  CricketAsiaCup = 2000057458,

  //rugby union
  RugbyUnionMenWC2027 = 1000093963,

  //rugby league
  RugbyLeagueEuropeanChampionship = 2000117596,
  RugbyLeagueFourNations = 2000051957,
  RugbyLeagueInternational = 2000120154,
  RugbyLeagueInternationalW = 2000120155,
  RugbyLeagueOceaniaCup = 2000119755,
  RugbyLeaguePacificChampionships = 2010200641,
  RugbyLeaguePacificChampionshipsW = 2010200589,
  RugbyLeagueWorldClubChallenge = 1000280266,
  RugbyLeagueWorldCup = 1000275860,
  RugbyLeagueWorldCupW = 2000111675,
  RugbyLeagueWorldCup9s = 2000121374,
  RugbyLeagueWorldCup9sW = 2000121375,

  //football
  FootballWC2026 = 2010133908,
  FootballWC2022 = 2000075007,
  FootballWCQualifier2026 = 2000086374,
  FootballWCMatches = 2000076408,
  FootballCopaAmerica = 1000093398,
  FootballFIFAClubWorldCup = 1000246008,
  FootballWorldCupQualifyingEurope = 2000086372,
  FootballWorldCupQualifyingAsia = 2000086367,
  FootballWorldCupQualifyingAfrica = 2000086368,
  FootballAfricaCupOfNations = 1000123032,
  FootballAsianGames = 2010200501,
  FootballAsianGamesMen = 2010200502,
  FootballAsianGamesWomen = 2010200503,

  //f1
  F1 = 2010132269,
  F1Race = 2010132272,
  F1SeasonBet = 2010132274,

  //ufc
  UFC = 1000093883,

  //basketball
  BasketballAfrobasket = 2000051568,
  BasketballAfrobasketW = 2000056259,
  BasketballAfrobasketWQualifiers = 2000120604,
  BasketballAfrobasketQualifiers = 2000120603,
  BasketballAsianGames = 2010200498,
  BasketballAsianGamesMen = 2010200499,
  BasketballAsianGamesWomen = 2010200500,
  BasketballEuroBasket = 2000088607,
  BasketballEuroBasketW = 2000112072,
  BasketballEuroBasketQualification = 2000066157,
  BasketballEuroBasketQualificationW = 2000066024,
  BasketballEuroCup = 1000093449,
  BasketballEuroCupW = 2000050693,
  BasketballEuroCupQualificationW = 2010133640,
  BasketballFIBA3x3WorldCup = 2000115562,
  BasketballFIBA3x3WorldCupW = 2000115565,
  BasketballFIBAAmeriCup = 1000174927,
  BasketballFIBAAmeriCupW = 2000051757,
  BasketballFIBAAmeriCupQualification = 2000123506,
  BasketballFIBAAsiaChampionsCup = 2000055442,
  BasketballFIBAAsiaChampionsCupQual = 2000115394,
  BasketballFIBAAsiaChampionship = 2000051565,
  BasketballFIBAAsiaCup = 2000116118,
  BasketballFIBAAsiaCupW = 2000121936,
  BasketballFIBAAsiaCupQualification = 2000061152,
  BasketballFIBACaribbeanChampionshipW = 2010133078,
  BasketballFIBACentralAmericanChampionshipW = 2010133079,
  BasketballFIBACentralAmericanChampionshipU19W = 2010205723,
  BasketballFIBACentrobasketChampionship = 2000058745,
  BasketballFIBACentrobasketChampionshipW = 2000058747,
  BasketballFIBAOceaniaChampionships = 2000056109,
  BasketballFIBAOceaniaChampionshipsW = 2000051724,
  BasketballFIBASouthAmericanChampionship = 2000058743,
  BasketballFIBASouthAmericanChampionshipW = 2000053867,
  BasketballFIBAWorldCup = 1000093936,
  BasketballFIBAWorldCupW = 1000174256,
  BasketballFIBAWorldCupWQualification = 2010132446,
  BasketballFIBAWorldCupWQualificationAfrica = 2000122001,
  BasketballFIBAWorldCupWQualificationAmericas = 2000121998,
  BasketballFIBAWorldCupWQualificationAsia = 2000121999,
  BasketballFIBAWorldCupWQualificationEurope = 2000122000,
  BasketballFIBAWorldCupQualificationAfrica = 2000111715,
  BasketballFIBAWorldCupQualificationAmericas = 2000111714,
  BasketballFIBAWorldCupQualificationAsia = 2000111713,
  BasketballFIBAWorldCupQualificationEurope = 2000108873,
  BasketballInternationalFriendlyMatches = 1000093567,
  BasketballInternationalFriendlyMatchesW = 1000186350,
  BasketballInternationalTournaments = 1000174871,
  BasketballInternationalTournamentsAfroCan = 2000121156,
  BasketballInternationalTournamentsArabChampionship = 2010201163,
  BasketballInternationalTournamentsCentralAmericanAndCaribbeanGames = 2010200070,
  BasketballInternationalTournamentsEuropeanChampionshipForSmallCountries = 2000059384,
  BasketballInternationalTournamentsGamesOfTheSmallStatesOfEurope = 2000087349,
  BasketballInternationalTournamentsSouthAsianGames = 2000056606,
  BasketballInternationalTournamentsSouthEastAsianGames = 2010132868,
  BasketballInternationalTournamentsWilliamJonesCup = 2000051398,
  BasketballInternationalTournamentsW = 1000195635,
  BasketballInternationalTournamentsWCentralAmericanAndCaribbeanGames = 2010200069,
  BasketballInternationalTournamentsWEuropeanChampionshipForSmallCountries = 2000059607,
  BasketballInternationalTournamentsWGamesOfTheSmallStatesOfEurope = 2000066003,
  BasketballInternationalTournamentsWSouthAsianGames = 2000056608,
  BasketballInternationalTournamentsWSouthEastAsianGames = 2010132869,
  BasketballInternationalTournamentsWWilliamJonesCup = 2000051400,
  BasketballInternationalYouthFriendlies = 2000059545,
  BasketballInternationalYouthFriendliesUnder18 = 2000059548,
  BasketballInternationalYouthFriendliesUnder19 = 2000059549,
  BasketballInternationalYouthFriendliesUnder20 = 2000059550,
  BasketballInternationalYouthFriendliesUnder21 = 2000059551,
  BasketballInternationalYouthFriendliesUnder23 = 2000059553,
  BasketballInternationalYouthFriendliesW = 2000059546,
  BasketballInternationalYouthFriendliesWUnder17 = 2000059554,
  BasketballInternationalYouthFriendliesWUnder18 = 2000059555,
  BasketballInternationalYouthFriendliesWUnder19 = 2000059556,
  BasketballInternationalYouthFriendliesWUnder20 = 2000059557,
  BasketballInternationalYouthFriendliesWUnder21 = 2000059558,
  BasketballInternationalYouthFriendliesWUnder22 = 2000059559,
  BasketballInternationalYouthFriendliesWUnder23 = 2000059560,
  BasketballInternationalYouthTournaments = 2000059409,
  BasketballInternationalYouthTournamentsAmericasChampionshipU21 = 2000116512,
  BasketballInternationalYouthTournamentsBalticSeaCupU18 = 2000082987,
  BasketballInternationalYouthTournamentsEuropeanChampionshipU18 = 2000059412,
  BasketballInternationalYouthTournamentsEuropeanChampionshipU19 = 2000059414,
  BasketballInternationalYouthTournamentsEuropeanChampionshipU20DivA = 2000059416,
  BasketballInternationalYouthTournamentsEuropeanChampionshipU20DivB = 2000059725,
  BasketballInternationalYouthTournamentsFIBAEuropeanChallengersU20 = 2000131000,
  BasketballInternationalYouthTournamentsFIBASouthAmericanChampionshipU18 = 2010132663,
  BasketballInternationalYouthTournamentsOceaniaChampionshipsU19 = 2000082327,
  BasketballInternationalYouthTournamentsWorldCupU17 = 2000059411,
  BasketballInternationalYouthTournamentsWorldCupU19 = 2000059415,
  BasketballInternationalYouthTournamentsW = 2000059418,
  BasketballInternationalYouthTournamentsWAmericasChampionshipU17 = 2000059420,
  BasketballInternationalYouthTournamentsWBalticSeaCupU18 = 2000082989,
  BasketballInternationalYouthTournamentsWEuropeanChampionshipU16 = 2000059419,
  BasketballInternationalYouthTournamentsWEuropeanChampionshipU18 = 2000059422,
  BasketballInternationalYouthTournamentsWEuropeanChampionshipU19 = 2000059423,
  BasketballInternationalYouthTournamentsWEuropeanChampionshipU20DivA = 2000059425,
  BasketballInternationalYouthTournamentsWEuropeanChampionshipU20DivB = 2000060185,
  BasketballInternationalYouthTournamentsWFIBAEuropeanChallengersU20 = 2000130999,
  BasketballInternationalYouthTournamentsWOceaniaChampionshipU19 = 2000061450,
  BasketballInternationalYouthTournamentsWWorldCupU19 = 2000059424,
  BasketballOlympicGames = 1000372601,
  BasketballOlympicGamesMen = 1000372602,
  BasketballOlympicGamesWomen = 1000372603,
  BasketballOlympicQualification = 1000302620,
  BasketballOlympicQualificationW = 1000302621,
}

// cspell:words Afrobasket Ameri Centrobasket Copa FIBA ICCT ICCWC WFIBA
